import {StatusProcessamento} from "./status-processamento.model";

export class ExecutarProcessamento {
    carteiras: number[];
    dataProcessar: Date;
}

export class ProcessamentoPeriodoModel {
    constructor(
        public carteiras: number[],
        public dataInicio: String,
        public dataFim: String
    ) {}
}

export class ProcessamentoFilter {
    constructor(
        public filtro: DetalhesProcessamentoCarteiraFilter,
        public dataProcessamento: string,
    ) {}
}

export class ProcessamentoPeriodoFilter {
    constructor(
        public filtro: DetalhesProcessamentoCarteiraFilter,
        public dataInicio: String,
        public dataFim: String,
    ) {}
}

export class DetalhesProcessamentoCarteiraFilter {
    constructor(
        public carteiraId: string | null,
        public grupoCarteiraId: number | null,
        public dataUltimoProcessamento: string | null,
        public status: StatusProcessamento,
    ) {}
}
